module.exports = __webpack_public_path__ + "887f8ebc6486d8610615cf5a56bce78d.png";